import { StorageFile } from "../../src/types/StorageFile";

export default function createStorageFile({ file, metadata }) {
	const { id, name, fullPath, url, size, duration, created } = file;

	switch (metadata.contentType) {
		case "audio/wav":
		case "audio/wave":
		case "audio/mpeg":
		case "application/epub+zip":
		case "application/pdf":
			return {
				...metadata,
				id,
				name,
				fullPath,
				url,
				size,
				duration,
				created,
			};
		default:
			return StorageFile.parse({
				...metadata,
				name,
				fullPath,
				url,
				size,
				created,
			});
	}
}
